/* 
  defaultAllowedVisitTypes are referenced from
  api-gateway gtiFilter.filters, combined to visitTypes.whitelist
  This means types PU, KI and HS are not needed on frontend
  since those types will be filtered out of timeline.
 */
const defaultAllowedVisitTypes = [
  'ENSIKÄYNTI, AJANVARAUS',
  'UUSIKÄYNTI',
  'SARJAHOITO',
  'HOIDON OHJAUS',
  'HOITOPUHELU',
  'ESEURANTA',
  'ETÄ, ENSIKÄYNTI',
  'ETÄ, UUSINTAKÄYNTI',
  'ETÄ, HOIDON OHJAUS',
  'ETÄ, SARJAHOITO',
];

/*
  GTIFIlterValues are referenced from api-gateway gtiFilter.filters
 */
const GTIFilterValues = {
  '(PRK)': {
    allowedVisitTypes: defaultAllowedVisitTypes,
  },
  '(PRE)': {
    allowedVisitTypes: defaultAllowedVisitTypes,
  },
  '(HPRE)': {
    allowedVisitTypes: defaultAllowedVisitTypes,
  },
  '(VMPSS)': {
    ruleSets: [
      {
        allowedResources: ['LÄÄK3_VMPSS'],
        allowedVisitTypes: defaultAllowedVisitTypes,
      },
    ],
  },
  '(VKPSS)': {
    ruleSets: [
      {
        allowedResources: ['PSSREUMA_VKPSS'],
        allowedVisitTypes: defaultAllowedVisitTypes,
      },
      {
        allowedResources: ['REUHOI_VKPSS'],
        allowedVisitTypes: defaultAllowedVisitTypes,
      },
    ],
  },
};

export const GTIFilter = (appointment) => {
  let { department, resource, visitType } = appointment;

  let unitKey = Object.keys(GTIFilterValues).filter((key) =>
    new RegExp(key).test(department)
  )[0];

  if (unitKey) {
    if (GTIFilterValues[unitKey].ruleSets) {
      return (
        GTIFilterValues[unitKey].ruleSets.filter(
          (ruleSet) =>
            (ruleSet.allowedResources == null ||
              ruleSet.allowedResources.length === 0 ||
              ruleSet.allowedResources.indexOf(resource.toUpperCase()) >= 0) &&
            visitType != null &&
            (ruleSet.allowedVisitTypes == null ||
              ruleSet.allowedVisitTypes.length === 0 ||
              ruleSet.allowedVisitTypes.indexOf(visitType.toUpperCase()) >= 0)
        ).length > 0
      );
    }
    return true;
  }
  return false;
};
